import face1a from '../images/faces/face1a.jpg';
import face1b from '../images/faces/face1b.jpg';
import face2a from '../images/faces/face2a.jpg';
import face2b from '../images/faces/face2b.jpg';
import face3a from '../images/faces/face3a.jpg';
import face3b from '../images/faces/face3b.jpg';
import face4a from '../images/faces/face4a.jpg';
import face4b from '../images/faces/face4b.jpg';
import face5a from '../images/faces/face5a.jpg';
import face5b from '../images/faces/face5b.jpg';
import face6a from '../images/faces/face6a.jpg';
import face6b from '../images/faces/face6b.jpg';

const faces = [
    face1a,
    face1b,
    face2a,
    face2b,
    face3a,
    face3b,
    face4a,
    face4b,
    face5a,
    face5b,
    face6a,
    face6b,
];

export default faces;